import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { EpxSvgIconComponent } from '@shared/components/misc/epx-svg-icon/epx-icon.component';

@Component({
    selector: 'epx-error-dialog',
    template: `
        <p-confirmDialog key="epx-error-dialog" styleClass="epx-confirm epx-error-dialog" #errorDialog [style]="{ width: 'fit-content', minWidth: '20rem' }">
            <ng-template pTemplate="header">
                <section class="w-full flex flex-row justify-content-between">
                    <div class="flex flex-row align-items-center justify-content-start font-bold gap-2">
                        <epx-svg-icon icon="alert_triangle"></epx-svg-icon>
                        <span [style.line-height.px]="20" [innerHTML]="'GENERAL.ERROR' | translate"></span>
                    </div>
                    <p-button (click)="errorDialog.onAccept()" class="epx-button epx-button-text">
                        <epx-svg-icon color="White" icon="x"></epx-svg-icon>
                    </p-button>
                </section>
            </ng-template>
            <ng-template pTemplate="message" let-message>
                <div class="flex flex-column align-items-start w-full gap-3 p-5">
                    <h5 [innerHTML]="'GENERAL.ERROR_SORRY' | translate"></h5>
                    <span>{{ message.message }}</span>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <div class="flex flex-row justify-content-end w-full"></div>
            </ng-template>
        </p-confirmDialog>
    `,
    imports: [TranslatePipe, ConfirmDialogModule, EpxSvgIconComponent, ButtonModule],
    styleUrls: ['./epx-error-dialog.component.scss']
})
export class EpxErrorDialogComponent {}
